module.exports = __webpack_public_path__ + "img/back3.47406252.png";